import { createSelector } from '@ngrx/store'
import { AccountState, selectAccountState } from '../account.root.state'
import { FormGroupState } from 'ngrx-forms'
import { Address } from '../user-profile/user-profile.state'

export interface AddressState {
  addresses: Address[]
  addressToEdit: Address
  editPageControls: FormGroupState<Address>
  newAddressControls: FormGroupState<Address>
}

export const selectAddressState = {
  addressState: createSelector(selectAccountState, (state: AccountState): AddressState => state.addressState),
  addresses: createSelector(selectAccountState, (state: AccountState): Address[] => state.addressState.addresses),
  addressToEdit: createSelector(selectAccountState, (state: AccountState): Address => state.addressState.addressToEdit),
  editPageControls: createSelector(
    selectAccountState,
    (state: AccountState): FormGroupState<Address> => state.addressState.editPageControls,
  ),
  newAddressControls: createSelector(
    selectAccountState,
    (state: AccountState): FormGroupState<Address> => state.addressState.newAddressControls,
  ),
} as const
